import { Star } from "lucide-react";
import type { ComponentProps } from "react";

import { ReviewEntity } from "../model";

import styles from "./star-rating-scale.module.css";

import { range } from "~/shared/arr";
import { cn } from "~/shared/ui";

type Props = ComponentProps<"div"> & {
  rating: ReviewEntity.RatingSchema;
} & (
    | {
        isEditable?: false | undefined;
        onRatingChange?: undefined;
      }
    | {
        isEditable: true;
        onRatingChange?: ((value: ReviewEntity.RatingSchema) => void) | undefined;
      }
  ) & {
    starProps?: ComponentProps<typeof Star> | undefined;
  };

function StarRatingScale({
  rating,
  isEditable,
  onRatingChange,
  className,
  starProps: { className: starClassName, ...starProps } = {},
  ...props
}: Props) {
  return (
    <div
      className={cn(
        "flex w-fit flex-row-reverse",
        isEditable && [styles["rating"], "hover:*:fill-none"],
        className,
      )}
      {...props}
    >
      {range(ReviewEntity.CONSTRAINTS.value.maximum)
        .reverse()
        .map((value) => {
          const normalizedValue = (value + 1) as ReviewEntity.RatingSchema;

          return (
            <Star
              key={normalizedValue}
              className={cn(
                "stroke-accent size-4",
                normalizedValue <= rating && "fill-accent",
                starClassName,
              )}
              onClick={() => onRatingChange?.(normalizedValue)}
              {...starProps}
            />
          );
        })}
    </div>
  );
}

export { StarRatingScale };
